import { errorToast, successToast } from "./globalFunctions";

export class ESService {
  constructor(token) {
    this.headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }
  errorHandling = (msg) => {
    if (
      msg === "Authentication credentials were not provided." ||
      msg === "Signature has expired."
    ) {
      window.location.href = "/auth?isTokenExpired=true";
    }
    return;
  };

  dataHandling = (data, status) => {
    if (status === 200 || status === 201) {
      if (
        data["message"] !== null &&
        data["message"] !== undefined &&
        data["message"] !== ""
      ) {
        successToast(data["message"]);
      }

      return { status: true, data: data["result"] };
    } else {
      this.errorHandling(data["message"]);
      errorToast(data["message"]);
      return { status: false, data: data };
    }
  };

  async get(url, params = "") {
    return fetch(url + "?" + params, {
      method: "GET",
      headers: this.headers,
    })
      .then(async (response) => {
        var data = await response.json();
        return this.dataHandling(data, response.status);
      })
      .catch((error) => {
        errorToast("Алдаа гарлаа");
        return { status: false };
      });
  }

  async post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        var data = await response.json();
        return this.dataHandling(data, response.status);
      })
      .catch((error) => {
        this.errorToast("Алдаа гарлаа");
        return { status: false };
      });
  }

  async put(url, body) {
    return fetch(url, {
      method: "PUT",
      headers: this.headers,
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        var data = await response.json();
        return this.dataHandling(data, response.status);
      })
      .catch((error) => {
        this.errorToast("Алдаа гарлаа");
        return { status: false };
      });
  }

  async delete(url, body) {
    return fetch(url, {
      method: "DELETE",
      headers: this.headers,
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        var data = await response.json();
        return this.dataHandling(data, response.status);
      })
      .catch((error) => {
        this.errorToast("Алдаа гарлаа");
        return { status: false };
      });
  }

  async loginPost(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then(async (response) => {
        var data = await response.json();
        return this.dataHandling(data, response.status);
      })
      .catch((error) => {
        this.errorToast("Алдаа гарлаа");
        return { status: false };
      });
  }
}
